package org.mkui.graphics

import org.mkui.font.MkFont
import org.mkui.geom.Rectangle2D
import web.canvas.ID
import web.canvas.OffscreenCanvas
import web.canvas.OffscreenCanvasRenderingContext2D

actual object CPHeadless : IHeadless {
//    private var textMeasurer: FontBoundedTextMeasurer? = null
    private val canvas by lazy { OffscreenCanvas(100.0, 100.0) }

    actual override fun getStringBounds(g: IGraphics?, font: MkFont?, text: String): Rectangle2D {
        if (g != null) {
            g.setFont(font)
            return g.getStringBounds(text)
        } else {
            return Rectangle2D.Double(0.0, 0.0, getStringWidth(g, font, text).toDouble(), getStringHeight(g, font, text).toDouble())
        }
    }

    actual override fun getStringWidth(g: IGraphics?, font: MkFont?, text: String): Float {
        if (g != null) {
            g.setFont(font)
            val width = g.getStringWidth(text)
            return width
        } else {
            val context2d = canvas.getContext(OffscreenCanvasRenderingContext2D.ID)!!
            context2d.font = font.toString()
            val width = context2d.measureText(text).width.toFloat()
            return width
//            return getTextMeasurer().measureTextWidth(context2d, text).toFloat()
//            return 0f
        }
    }

    actual override fun getStringHeight(g: IGraphics?, font: MkFont?, text: String): Float {
        if (g != null) {
            g.setFont(font)
            return g.getStringHeight(text)
        } else {
            return font!!.getSize2D().toFloat() * 100 / 96 * 130 / 100
        }
    }

//    private fun getTextMeasurer(): FontBoundedTextMeasurer {
//        if (textMeasurer == null) {
//            textMeasurer = FontBoundedTextMeasurer()
//        }
//        return textMeasurer!!
//    }

//    private fun getCanvas(): Canvas? {
//        if (canvas == null) {
//            canvas = Canvas.createIfSupported()
//            //            DOM.appendChild(DOM.canvas.getCanvasElement());
//        }
//        return canvas
//    }

//    class FontBoundedTextMeasurer {
//        // Hidden html tag used for measuring the of the text.
//        private var hiddenHtml: MutableMap<Canvas, Element?>? = null
//
//        fun measureTextWidth(surface: Context2d, text: String?): Double {
//            return surface.measureText(text).getWidth()
//        }
//
//        fun measureTextHeight(surface: Canvas, text: String?): Double {
//            if (hiddenHtml == null) {
//                hiddenHtml = HashMap<Canvas, Element?>()
//            }
//            // Caches the element for measuring height so we don't need to
//            // reattach it every time.
//            var elem: Element? = hiddenHtml!![surface]
//            if (elem == null) {
//                elem = DOM.createDiv()
//                elem.setInnerText("o")
//                val style: Style = elem.getStyle()
//                style.setProperty("margin", "0px")
//                style.setProperty("border", "0px")
//                style.setProperty("padding", "0px")
//                surface.getElement().appendChild(elem)
//                hiddenHtml!![surface] = elem
//            }
//            UIObject.setVisible(elem, true)
//            // All characters in the same font have the same height property, so we
//            // only need to use an arbitrary character to figure out the height,
//            // avoiding performance hit caused by long text.
//            elem.getStyle().setProperty("font", surface.getContext2d().getFont())
//            val height: Double = elem.getOffsetHeight()
//            UIObject.setVisible(elem, false)
//            return height
//        }
//    }
}